import { COMPANY_SELECTION_ROLES, CARBON_ACCOUNTING_ROLES, SWITCH_APP_ROLES, SUPPLY_CHAIN_ROLES } from "./constants";
import type { ROLE } from '@/types';

/**
 * Kullanıcının belirli rollere sahip olup olmadığını kontrol eder
 */
export const hasAnyRole = (userRoles: ROLE[], targetRoles: readonly string[]): boolean => {
  if (!userRoles || !Array.isArray(userRoles)) return false;

  const userRoleNames = userRoles.map(role => role.roleName);
  return targetRoles.some(role => userRoleNames.includes(role as any));
};

/**
 * Kullanıcının şirket seçimi gerektiren rollere sahip olup olmadığını kontrol eder
 */
export const requiresCompanySelection = (userRoles: ROLE[]): boolean => {
  return hasAnyRole(userRoles, COMPANY_SELECTION_ROLES);
};

/**
 * Kullanıcının carbon accounting rollere sahip olup olmadığını kontrol eder
 */
export const hasCarbonAccountingRole = (userRoles: ROLE[]): boolean => {
  return hasAnyRole(userRoles, CARBON_ACCOUNTING_ROLES);
};

export const hasSupplyChainRole = (userRoles: ROLE[]): boolean => {
  return hasAnyRole(userRoles, SUPPLY_CHAIN_ROLES);
};

export const hasSwitchAppRoles = (userRoles: ROLE[]): boolean => {
  return hasAnyRole(userRoles, SWITCH_APP_ROLES);
};
